module.exports = __webpack_public_path__ + "img/K.b2bab638.webp";